import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {action, computed, observable} from 'mobx';
import {observer} from 'mobx-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {isAdmin, isStudent} from '../../../utils/userUtility';
import LessonInfoFormAdminSection from './LessonInfoFormAdminSection';
import BaseButton from '../../../components/button/BaseButton';

@injectIntl
@observer
class LessonInfoForm extends Component {
    @observable focused = false;
    @observable isOpen = false;
    @observable maxHeight = this.initialHeight;
    initialHeight = 296;

    modules = {
        toolbar: [
            [{header: []}],
            [{align: []}, {direction: 'rtl'}],
            ['bold', 'italic', 'underline', 'strike'],
            [{color: []}, {background: []}],
            [{script: 'sub'}, {script: 'super'}]
        ],
        clipboard: {
            matchVisual: false,
        }
    };

    componentDidMount() {
        document.addEventListener('click', this.onDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.onDocumentClick);
    }

    componentDidUpdate(prevProps) {
        if (this.props.readMore && prevProps.form.description !== this.props.form.description) {
            this.setMaxHeight(this.calculateHeight());
        }
    }

    @action onDocumentClick = (e) => {
        if (!e.target.closest('.lesson-editor') && this.focused) {
            this.focused = false;
            this.reactQuillRef.blur();
        }
    };

    @action handleFocus = () => {
        this.focused = true;
    };

    @action toggleIsOpen = () => {
        this.isOpen = !this.isOpen;
    };

    @action setMaxHeight = (val) => {
        this.maxHeight = val;
    };

    calculateHeight() {
        return this.reactQuillRef && this.reactQuillRef.editingArea.offsetHeight;
    }

    @computed get isExpandable() {
        return this.props.readMore && (this.initialHeight < this.maxHeight) && !this.isOpen;
    }

    setRef = (node) => {
        this.reactQuillRef = node;
    };

    onChange = (content, delta, source, editor) => {
        if (source === 'user') { //call onChange function only if description changed by user (not initial set)
            this.props.onChangeDescription(content);
        }
    }

    render() {
        const {form, updateProjectForm, readMore, intl: {formatMessage: translate}} = this.props;
        const maxHeight = this.isOpen ? this.maxHeight : this.initialHeight;

        return (
            <div className="lesson-form">
                <h3 className="lesson-label">{translate({id:'createLesson.description'})}</h3>
                <div
                    style={readMore ? {maxHeight} : null}
                    className={`lesson-editor ${this.focused ? 'focused' : ''} ${this.isExpandable ? 'collapsed' : ''}`}>
                    <ReactQuill
                        ref={this.setRef}
                        onFocus={this.handleFocus}
                        modules={this.modules}
                        value={form.description}
                        placeholder={translate({id: `${isStudent() ? 'createLesson.editorStudentPlaceholder' : 'createLesson.editorTeacherPlaceholder'}`})}
                        onChange={this.onChange}/>
                </div>
                {this.isExpandable &&
                    <BaseButton onClick={this.toggleIsOpen} className="read-more" label={translate({id: 'general.readMore'})}/>
                }
                {isAdmin() && <LessonInfoFormAdminSection form={form} updateProjectForm={updateProjectForm}/>}
            </div>
        );
    }
}

LessonInfoForm.propTypes = {
    description: PropTypes.string,
    onChangeDescription: PropTypes.func,
    updateProjectForm: PropTypes.func
};

export default LessonInfoForm;
